export const SectionHeading = ({ kicker, title, subtitle, light = false }) => (
  <div className="max-w-2xl">
    {kicker && (
      <span className="text-sm font-semibold uppercase tracking-[0.2em] text-[#B12A2A]">
        {kicker}
      </span>
    )}
    <h2
      className={`mt-3 font-heading text-3xl font-semibold tracking-tight sm:text-4xl lg:text-5xl ${
        light ? "text-black" : "text-white"
      }`}
    >
      {title}
    </h2>
    {subtitle && (
      <p className={`mt-4 text-base leading-relaxed sm:text-lg ${light ? "text-black/60" : "text-white/60"}`}>
        {subtitle}
      </p>
    )}
  </div>
);
